import React from "react";
import "./MenuItem.sass"
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

export default function MenuItem(props) {
    const {name, url} = props

    return (
        <Link to={url || '/'} className="menu-item-wrapper">
            {name}
        </Link>
    )
}

MenuItem.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
}